module.exports = __webpack_public_path__ + "static/img/10.81d33a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/4/1/eng/10.png
// module id = w3h3
// module chunks = 0